<!-- 群标签 -->
<template>
  <div class="">
    <div class="head-title">群标签</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            根据企业实际情况在此添加新建群标签，也是客户群列表编辑群标签时的选择。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <nav class="navbar">
        <div class="nav-l">
          <el-input
            v-model.trim="tag_name"
            placeholder="新建标签"
            clearable
          ></el-input>
          <el-button
            style="margin-left: 2.4rem"
            type="primary"
            icon="el-icon-plus"
            @click="onAddTag"
            >确认添加</el-button
          >
        </div>
        <div class="nav-r">
          <el-input
            v-model.trim="q"
            prefix-icon="el-icon-search"
            style="width: 22.0rem; margin: 0 2.0rem 0 2.0rem"
            placeholder="请输入标签名搜索"
            clearable
            @change="getData"
          >
          </el-input>
          <el-button slot="append" type="primary" @click="getData"
            >查询</el-button
          >
        </div>
      </nav>
      <div style="margin-top: 2.0rem">
        <el-table :data="tableData" border v-loading="tableLoading">
          <el-table-column prop="tag_name" label="标签名">
            <template slot-scope="{ row }">
              <template v-if="row.edit">
                <el-input
                  clearable
                  v-model="row.tag_name"
                  size="small"
                  class="edit-input"
                  placeholder="请输入名称"
                ></el-input>
                <el-button
                  class="cancel-btn"
                  size="small"
                  icon="el-icon-refresh"
                  type="warning"
                  @click="cancelEdit(row)"
                >
                  取消
                </el-button>
              </template>
              <span v-else>{{ row.tag_name }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="createtime" label="创建时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.edit"
                type="success"
                size="mini"
                @click="confirmEdit(scope.row)"
              >
                确定
              </el-button>
              <el-button
                v-else
                size="mini"
                @click="onEdit(scope.row)"
                type="primary"
                >编辑</el-button
              >
              <el-button @click="onDel(scope.row)" size="mini" type="danger"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging">
        <pagination
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          :page-sizes="[10,20,50,100]"
          :auto-scroll="false"
          @pagination="getData"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "groupTags",
  data() {
    return {
      q: "",
      tag_name: "",
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      tableData: [],
      tableLoading: true,
    };
  },

  components: {},

  computed: {},

  mounted() {
    this.getData();
  },

  methods: {
    onEdit(row) {
      row.originalName = row.name;
      row.edit = true;
    },
    cancelEdit(row) {
      row.name = row.originalName;
      row.edit = false;
    },
    async confirmEdit(row) {
      const { data: res } = await this.axios({
        url: "/crm/LabelGroup/edit",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          id: row.id,
          tag_name: row.tag_name,
        }),
      });
      this.$message({
        type: res.code == 1 ? "success" : "error",
        message: res.msg,
      });
      this.getData();
    },
    async onAddTag() {
      if (!this.tag_name) {
        this.$message.error("请输入标签名称");
        return;
      }
      const { data: res } = await this.axios({
        url: "/crm/LabelGroup/add",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          tag_name: this.tag_name,
        }),
      });
      this.$message({
        type: res.code == 1 ? "success" : "error",
        message: res.msg,
      });
      this.tag_name = "";
      this.getData();
    },
    onDel(row) {
      this.$confirm("此操作将永久删除该条数据，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { data: res } = await this.axios({
            url: "/crm/LabelGroup/del",
            method: "POST",
            data: this.qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              phone: this.tooken.phone,
              id: row.id,
            }),
          });
          this.$message({
            type: res.code == 1 ? "success" : "error",
            message: res.msg,
          });
          this.q = "";
          this.getData();
        })
        .catch(() => {
          this.$message({
            message: "已取消删除",
            type: "info",
          });
        });
    },
    async getData() {
      const { data: res } = await this.axios({
        url: "/crm/LabelGroup/getList",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          page: this.listQuery.page,
          number_page:this.listQuery.limit,
          name: this.q,
        }),
      });
      this.tableLoading = false;
      if (res.code == 1) {
        res.data.forEach((i) => {
          i.edit = false;
        });
        this.tableData = res.data;
        this.total = res.count;
      } else {
        this.tableData = res.data;
        this.total = res.count;
      }
    },
  },
};
</script>
<style  scoped>
.nav-l {
  display: flex;
}
.edit-input {
  padding-right: 10.0rem;
}
.cancel-btn {
  position: absolute;
  right: 1.5rem;
  top: 1.0rem;
}
</style>
